// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3GpkN","colMin":"styles_colMin__LxnLj","colCheckbox":"styles_colCheckbox__3jKnV"};